export const ROUTE_PATH_HOME = '';

export const ROUTE_PATH_404 = '404';
